import React from 'react';

import Hooks from '@benzinga/hooks';
import styled, { StyledComponents } from '@benzinga/themetron';
import { StockSymbol } from '@benzinga/session';
import { isNotNil } from '@benzinga/utils';
import { useQuoteSubscription } from '@benzinga/quotes-manager-hooks';

const { keyframes } = StyledComponents;
interface Props {
  symbol: StockSymbol;
}

export const TickerPrice: React.FC<Props> = props => {
  const { quote } = useQuoteSubscription(props.symbol);
  const prevQuote = Hooks.usePrevious(quote);

  if (isNotNil(quote) && isNotNil(quote.currentPrice) && isNotNil(prevQuote) && isNotNil(prevQuote.currentPrice)) {
    if (quote.currentPrice > prevQuote.currentPrice) {
      return (
        <GreenPriceDiv>
          <PriceDiv>{quote.currentPrice}</PriceDiv>
        </GreenPriceDiv>
      );
    } else if (quote?.currentPrice < prevQuote.currentPrice) {
      return (
        <RedPriceDiv>
          <PriceDiv>{quote.currentPrice}</PriceDiv>
        </RedPriceDiv>
      );
    } else {
      return <PriceDiv>{quote.currentPrice}</PriceDiv>;
    }
  } else if (quote) {
    return <PriceDiv>{quote.currentPrice}</PriceDiv>;
  } else {
    return null;
  }
};

const FlashGreen = keyframes`
  0% {
    background-color: rgba($bz-positive, 0.75);
    color: $bz-white;
  }
  50% {
    background-color: rgba($bz-positive, 0.75);
    color: $bz-white;
  }
  100% {
    background-color: inherit;
    color: inherit;
  }
`;

const FlashRed = keyframes`
  0% {
    background-color: rgba($bz-positive, 0.75);
    color: $bz-white;
  }
  50% {
    background-color: rgba($bz-positive, 0.75);
    color: $bz-white;
  }
  100% {
    background-color: inherit;
    color: inherit;
  }
`;

const PriceDiv = styled.div`
  padding: 0 11px;
  color: $bz-white;
`;

const GreenPriceDiv = styled.div`
  animation: ${FlashGreen} 0.5s linear;
`;

const RedPriceDiv = styled.div`
  animation: ${FlashRed} 0.5s linear;
`;
